import {
  type CurrentUser,
  type VpnClient,
  api,
} from "./api"

export const VPN_CLIENT_SYNC_INTERVAL_MS = 5 * 60 * 1000

export type VpnClientSyncResult = {
  clients: VpnClient[]
  lastSyncedAt: string
  log: string
}

const inFlightSyncs = new Map<string, Promise<VpnClientSyncResult>>()

export function canSyncVpnClients(
  user: Pick<CurrentUser, "permissions"> | null | undefined
): boolean {
  return Boolean(
    user?.permissions.some((permission) =>
      ["view", "create", "download"].includes(permission)
    )
  )
}

export function syncVpnClients(
  machineName: string
): Promise<VpnClientSyncResult> {
  const normalizedMachineName = machineName.trim()
  if (!normalizedMachineName) {
    return Promise.reject(new Error("Selecione um ambiente para sincronizar."))
  }

  const activeSync = inFlightSyncs.get(normalizedMachineName)
  if (activeSync) return activeSync

  const nextSync = api.refreshClients(normalizedMachineName).finally(() => {
    inFlightSyncs.delete(normalizedMachineName)
  })
  inFlightSyncs.set(normalizedMachineName, nextSync)
  return nextSync
}
